<div class="accordion" id="accordionGestion">
    <div class="card">
        <div class="card-header" id="gestionPannesHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#gestionPannesCollapse" aria-expanded="true" aria-controls="gestionPannesCollapse">
                Zones
            </button>
        </div>

        <div id="gestionPannesCollapse" class="panel-collapse collapse" aria-labelledby="gestionPannesHeader"
            data-parent="#accordionGestion">

            <div class="card-body row">

                <div class="wrapper shadowed">
                    <h5>Zones principales</h5>
                    <p>Ajout</p>
                    <form [formGroup]="pannesCategoriesForm" (ngSubmit)="onSubmitCategoryForm()">
                        <mat-form-field>
                            <mat-label>Nom de la zone</mat-label>
                            <input matInput formControlName="cat_nom">
                        </mat-form-field>

                        <mat-form-field class="inputCodeCat">
                            <mat-label>Code de la zone</mat-label>
                            <input matInput formControlName="cat_code">
                        </mat-form-field>


                        <button type="submit" class="btn btn-primary submit"
                            [disabled]="!pannesCategoriesForm.valid">Enregistrer</button>

                    </form>

                    <br>

                    <button class="btn btn-primary" (click)="onClickVoirCategories()">{{ catMessage }}</button>


                    <div class="displayCatList" *ngIf=displayCategoryList>
                        
                        <mat-table [dataSource]="categoryBreakdownList">
                  
                            <ng-container matColumnDef="nom">
                                <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                                <mat-cell *matCellDef="let cat"> {{cat.cat_nom}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="code">
                                <mat-header-cell *matHeaderCellDef> Code </mat-header-cell>
                                <mat-cell *matCellDef="let cat"> {{cat.cat_code}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="edit">
                                <mat-header-cell *matHeaderCellDef> Editer </mat-header-cell>
                                <mat-cell  *matCellDef="let cat"> <mat-icon (click)="editCategory(cat)">edit</mat-icon> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="delete">
                                <mat-header-cell *matHeaderCellDef> Supprimer </mat-header-cell>
                                <mat-cell *matCellDef="let cat">
                                    <mat-icon (click)="onDeleteCategory(cat.cat_id, cat)">delete</mat-icon>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnCat"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: ['nom', 'code', 'edit', 'delete'] ;"></mat-row>
                        </mat-table>
                    </div>

                </div>

                <div class="wrapper shadowed">
                    <h5>Zones</h5>
                    <p>Ajout d'une zone</p>
                    <form [formGroup]="codesPannesForm" (ngSubmit)="onSubmitCodesPannesForm()">
                        <mat-form-field>
                            <mat-label>Nom de la zone</mat-label>
                            <input matInput formControlName="code_nom">
                        </mat-form-field>

                        <mat-form-field class="inputCodeCat">
                            <mat-label>Code de la zone</mat-label>
                            <mat-select formControlName="cat_id">
                                <mat-option *ngFor="let category of tCategories" [value]="category.id">{{ category.code
                                    }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <button type="submit" class="btn btn-primary submit"
                            [disabled]="!codesPannesForm.valid">Enregistrer</button>

                    </form>

                    <br>

                    <button class="btn btn-primary" (click)="onClickVoirCodesListe()">{{ codeMessage }}</button>

                    <div class="displayCodesList" *ngIf=displayCodesList>

                        <mat-table [dataSource]="codesBreakdownList">
                            <ng-container matColumnDef="code">
                                <mat-header-cell *matHeaderCellDef> Code </mat-header-cell>
                                <mat-cell *matCellDef="let code"> {{code.code}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="nom">
                                <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                                <mat-cell *matCellDef="let code"> {{code.nom}} </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="edit">
                                <mat-header-cell *matHeaderCellDef> Editer </mat-header-cell>
                                <mat-cell  *matCellDef="let code"> <mat-icon (click)="editCodeBreakdown(code)">edit</mat-icon> </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="delete">
                                <mat-header-cell *matHeaderCellDef> Supprimer </mat-header-cell>
                                <mat-cell *matCellDef="let code">
                                    <mat-icon (click)="onDeleteCode(code.code, code)">delete</mat-icon>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumnCode"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: ['code', 'nom', 'edit', 'delete'] ;"></mat-row>
                        </mat-table>

                    </div>

                </div>

            </div>

        </div>


        <div class="card-header" id="gestionTypeAppelsHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#gestionTypeAppelsCollapse" aria-expanded="true" aria-controls="gestionTypeAppelsCollapse">
                Types d'appels
            </button>
        </div>

        <div id="gestionTypeAppelsCollapse" class="panel-collapse collapse" aria-labelledby="gestionTypeAppelsHeader"
            data-parent="#accordionGestion">

            <div class="card-body row">
                    <app-gestion-appels-sav style="width: 100%;"></app-gestion-appels-sav>
            </div>
        </div>

        
        <div class="card-header" id="gestionActionsHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#gestionActionsCollapse" aria-expanded="true" aria-controls="gestionActionsCollapse">
                Actions du SAV
            </button>
        </div> 

       <div id="gestionActionsCollapse" class="panel-collapse collapse" aria-labelledby="gestionActionsHeader"
            data-parent="#accordionGestion">

            <div class="card-body row">
                <app-gestion-actions-sav style="width: 100%;"></app-gestion-actions-sav>
            </div>
        </div>



        <div class="card-header" id="gestionIntervenantsHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#gestionIntervenantsCollapse" aria-expanded="true" aria-controls="gestionIntervenantsCollapse">
                Intervenants
            </button>
        </div>

        <div id="gestionIntervenantsCollapse" class="panel-collapse collapse" aria-labelledby="gestionIntervenantsHeader"
            data-parent="#accordionGestion">

            <div class="card-body row">
                <app-gestion-intervenants-sav style="width: 100%;"></app-gestion-intervenants-sav>
            </div>
        </div> 


        <!-- <div class="card-header" id="gestionGeogAreaHeader">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                data-target="#gestionGeogAreaCollapse" aria-expanded="true" aria-controls="gestionGeogAreaCollapse">
                Zones commerciales
            </button>
        </div> -->

        <div id="gestionGeogAreaCollapse" class="panel-collapse collapse" aria-labelledby="gestionGeogAreaHeader"
            data-parent="#accordionGestion">

            <div class="card-body row">
                <app-gestion-comm-area style="width: 100%;"></app-gestion-comm-area>
            </div>
        </div> 



    </div>
</div>

